<template>
	<div class="page-content" style="margin-bottom: 80px;">
		<FixedTool />
		<div class="banner"><img style="width:100%;height:100%;" src="../../assets/images/jxrz.gif"></div>
		<nut-noticebar :leftIcon="require('../../assets/images/icon_danger1.png')" :background="'#FFE6CD'" :color="'#666'" text="提示：驾校会展示到车之驭中，入驻需要审核，用于营销、招生、管理" class="prompt"></nut-noticebar>
		<div class="myform">
			<EnterForm ref="freeform"></EnterForm>
		</div>
		<div class="footer">
			<div class="btn" @click="helpFindDriving">立即入驻</div>
			<p>
				如有任何疑问请联系我们<br/>
				电话：
				<span style="text-decoration:underline" @click="card_phone(conf.card_phone)">{{conf.card_phone}}</span>
				微信号：
				<a href="javascript:void(0)" style="text-decoration:underline" @click="copy(conf.card_wechat)">{{conf.card_wechat}}</a>
			</p>
		</div>
	</div>
</template>

<script>
import EnterForm from '@/components/EnterForm'
export default {
	name: 'ApplicationIn',
	components: {EnterForm},
	data:()=> ({
		conf: {},
	}),
	created() {
		this.getConf();
	},
	beforeCreate () {
		document.title = '驾校入驻';
	},
	methods: {
		// 提交表单
		helpFindDriving() {
			this.$refs.freeform.submit();
		},
		getConf() {
			this.$ajax.get('m/system/conf').then(res => {
				this.conf = res;
				document.title = '驾校入驻';
			})
		},
		card_phone(tel){
			this.$dialog({
				title: "提示",
				okBtnTxt:"拨打",
				content: "拨打电话：<span style='color: #3c47ed;'>"+tel+"</span>",
				onOkBtn() {  		//确定按钮点击事件
					this.close(); 	//关闭对话框
					window.location.href = 'tel://'+tel;
				},
			});
		},
		copy(text){
			const input = document.createElement('input')
			document.body.appendChild(input)
			input.setAttribute('value', text)
			input.select()
			if (document.execCommand('copy')) {
				document.execCommand('copy')
				this.$toast.text('复制成功');
			}
			document.body.removeChild(input)
		}
	},
	mounted() {

	}
}
</script>

<style lang="less" scoped>
	.page-content {
		width: 100%;
		.prompt {
			width: 100%;
			height: 30px;
			box-sizing: border-box;
			font-size: 12px;
			margin-top: -6px;
		}
		.myform {
			width: 100%;
			box-sizing: border-box;
			padding: 0 15px;
			.form-list {
				width: 100%;
				height: 82px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				box-sizing: border-box;
				padding-top: 15px;
				.label {
					font-size: 14px;
					color: #333;
				}
				.val-content {
					display: flex;
					align-items: center;
					justify-content: space-between;
					border-bottom: 1px #E2E2E2 solid;
					.input {
						font-size: 13px;
						flex: 1;
					}
					span {
						font-size: 14px;
						color: #3C43EC;
					}
				}
				.error-prompt {
					width: 100%;
					display: flex;
					align-items: center;
					span {
						font-size: 12px;
						color: #EB273B;
						margin-left: 5px;
					}
				}
			}
		}
		.footer {
			width: 100%;
			box-sizing: border-box;
			padding: 18px 15px;
			margin: 30px 0 20px;
			.btn {
				width: 100%;
				height: 40px;
				line-height: 40px;
				text-align: center;
				background: linear-gradient(222deg,rgba(0,194,255,1) 0%,rgba(60,67,236,1) 100%);
				border-radius: 25px;
				font-size: 15px;
				font-weight: bold;
				color: #fff;
			}
			p {
				font-size: 12px;
				color: #999;
				margin-top: 20px;
				text-align: center;
				width: 100%;
				span {
					text-decoration: underline;
					color: #3C43EC;
				}
			}
		}
	}

	/deep/ .nut-textinput-disabled input {
		background-color: #fff;
		color: #333;
	}
	/deep/ .nut-textinput input {
		height: 30px;
		padding: 0;
	}
</style>
